import React, { useEffect } from 'react';

import { useAds } from 'hooks/use-ads';
import { AdSlotMarker, AdSlotMarkerProps } from 'components/ads/ad-slot-marker';

import './ad-slot.scss';

const AdSlot: React.FC<AdSlotMarkerProps> = ({
    id,
    name,
    lazy,
    slotId,
    resizable,
    injectAdsenseOnEmpty,
    className = '',
    isMobile = false
}) => {
    const ads = useAds();

    if (!ads?.enabled || ads?.kwrd?.includes('adult')) {
        return null;
    }

    useEffect((): void => {
        window?.dlApi?.cmd.push((dlApi): void => {
            const slot: OnetSlot = dlApi.defineSlot(name, id || `ad-${name}`, {}).setCollapseEmpty(false);

            if (injectAdsenseOnEmpty) {
                slot.on('empty', emptySlot => {
                    document.Opineo.Google.AdSense.injectAd(emptySlot.div);
                });
            }

            dlApi.fetch();
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AdSlotMarker
            id={id || `ad-${name}`}
            name={name}
            auto={false}
            lazy={lazy}
            slotId={slotId}
            resizable={resizable}
            className={className}
            isMobile={isMobile}
        />
    );
};

export default AdSlot;
